import React, { useState, useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import Navbar from "../../common/Navbar/Navbar";
import DownloadReport from "../../Modals/DownloadReport/DownloadReport";
import ReportsTabs from "../Tabs/ReportTabs";
import MapsModal from "../../Modals/MapsTooltipsModal/MapsModal";
import DownloadMaps from "../../Modals/DownloadMaps/DownloadMaps";
import { fetchSnapshotCSV } from "../../s3/FetchSnapshotData";

import './reportHeader.css'

//This page renders all the reports inside the parent Reports.jsx:
//TextReport.jsx, EvidenceMap.jsx and TreeMap.jsx

function ReportsHeader({ defaultType }) {
  const timestamp = localStorage.getItem("timestamp");
  const [toggleState, setToggleState] = useState(defaultType);
  const navigate = useNavigate();
  const initialFileName = localStorage.getItem("initialFileName");
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);

  useEffect(() => {
    getS3().then(setS3);
  }, [])

  // Enable toggle functionality for tabs (active tab)
  const toggleTab = (status) => {
    setToggleState(status);
    navigate(`/reports/${status.toLowerCase().replace(" ", "")}`);
  };

  // On done button click, navigate to forms
  const handleDoneClick = async () => {
    //Make sure all data properties related to the CSV are set in localstorage
     await fetchSnapshotCSV(S3, initialFileName, "Snapshots"); 
    
    //use navigate to redirect to redirect to the input form page with the document name as a parameter
    navigate(`/inputform/${initialFileName}`);
  };

  return (
    <>
      <Navbar />
      <div className="grid-container">
        <div className="header-reports">
          <div className="header-title-reports">
            {toggleState}
          </div>

          <div className="search-bar-reports">
          <div className="report-timestamp">
              Report Generated: {timestamp}
            </div>
           
              <MapsModal />
        
            {defaultType === "Text Report" ? (
              <DownloadReport />
            ) : (
              (defaultType === "Evidence Map" || defaultType === "Treemap") && (
                <DownloadMaps
                  defaultType={defaultType}
                  evidenceMapContainer="evidencemap"
                />
                // Pass the evidenceMapContainer as a string, or provide the actual HTML element
              )
            )}
            <button className="green-button" onClick={handleDoneClick} style={{ fontSize: "14px", width: "80px" }} >
              Done
            </button>
          </div>
        </div>

        <ReportsTabs toggleState={toggleState} toggleTab={toggleTab} />
      </div>
      {/* {timestamp ? (<Outlet />): (<p>No data available</p>)} */}
      
    </>
  );
}

export default ReportsHeader;
